import cn from "classnames"
import React from "react"
import { useTranslation } from "react-i18next"
import { CircleOutline, CheckmarkFill } from "@/skylticons"

interface SelectedIndicatorProps {
  active?: boolean
}

const SelectedIndicator: React.FC<SelectedIndicatorProps> = ({ active }) => {
  const { t } = useTranslation()

  return (
    <span className={cn("flex items-center justify-end", { "text-white-20": !active, "text-blue-500": active })}>
      {active ? (
        <>
          <span className="paragraph-2xs bold mb-0 mr-1 w-auto !text-blue-500">{t("toolbox.selected")}</span>
          <CheckmarkFill className="h-6 min-w-6" />
        </>
      ) : (
        <CircleOutline className="h-6 min-w-6" />
      )}
    </span>
  )
}

export default SelectedIndicator
